/* global axios */
import ApiClient from './ApiClient';

class TalkviaPixKeysAPI extends ApiClient {
  constructor() {
    super('talkvia_pix_keys', { accountScoped: true });
  }

  generate(id, params) {
    return axios.post(`${this.url}/${id}/generate`, params);
  }

  requestCode() {
    return axios.post(`${this.url}/request_code`);
  }
}

export default new TalkviaPixKeysAPI();
